(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexajoy-match-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nexajoy-showcase')) {
  customElements.define('nexajoy-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-nj-select]');
        if (button && this.contains(button)) this.select(button);
      });
      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('button[data-nj-select]');
        if (!button || !this.contains(button)) return;
        const buttons = Array.from(this.querySelectorAll('button[data-nj-select]'));
        const index = buttons.indexOf(button);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        this.select(buttons[next]);
        buttons[next].focus();
      });
    }
    select(button) {
      const handle = button.dataset.njSelect;
      this.querySelectorAll('[data-nj-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.njPanel !== handle;
        if (!panel.hidden) panel.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
      });
      this.querySelectorAll('button[data-nj-select]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item === button));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
